var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiCard',[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('ReportTitle')],1),_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('BarChart',{attrs:{"chart-data":_vm.datacollection,"css-classes":"finances-chart-container"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }